<template>
  <v-container fluid class="marketplatform-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Marketing Platform</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Platform</p>
                        <v-select
                          class="mb-4"
                          :items=marketplatformtype
                          v-model="marketplatform.platformtype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the platform type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="marketplatform.platformname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Platform Name"
                          persistent-hint
                          single-line hint="Enter the platform name">
                        </v-text-field>
                      </v-form>
                    </v-col>                               
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/marketplatform/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertMarketPlatform()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      error: undefined,
      errortag: false,
      errorindex: undefined,
      imageurl: undefined,
      step: 1,
      marketplatform: {},
      marketplatformtype: ['Facebook', 'Instagram', 'TikTok', 'Telegram', 'WhatsApp', 'YouTube'],
    }
  },
  computed: {
    ...mapState('MarketPlatform', ['isReceiving']),
  },
  methods: {
    ...mapActions('MarketPlatform', ['getMarketPlatforms', 'insertMarketPlatformRequest', 'insertMarketPlatformWithImageRequest']),
    checkError(){
      if(!this.marketplatform.platformtype){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.marketplatform.platformname){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertMarketPlatform() {
      if(this.marketplatform.imagefile!=null) await this.insertMarketPlatformWithImageRequest(this.marketplatform);
      else await this.insertMarketPlatformRequest(this.marketplatform);
      router.push('/marketplatform/list');
    },
    onFileChange(file) {
      if (!file) {return;}
      this.marketplatform.imagefile = file;
      this.marketplatform.imagename = file.name;
      this.createImage(file);
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },
  },
  async created () {

  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
